import type { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Box, Stack } from '@atlaskit/primitives';
import { useToken } from '../../../Flow/ConsentContextProvider';
import WorkspacePanel from './WorkspacePanel';
import { RestrictedWorkspace } from './RestrictedWorkspace';
import { GraphQLNotConnectedFallback } from '../../../GraphQL/Fallback';
import { WorkspaceFooter } from './WorkspaceFooter';

const messages = defineMessages({
  headerRestrictedWorkspace: {
    id: 'trello.workspaces.header.restrictedWorkspace',
    defaultMessage:
      '{appName} will have access to <strong>this Workspace and its boards</strong>:',
    description:
      'Header describing that consenting to this application allows the app to access the following workspaces and the boards in it',
  },
  headerUnrestrictedWorkspace: {
    id: 'trello.workspaces.header.unrestrictedWorkspace',
    defaultMessage:
      '{appName} will have access to <strong>all Workspaces and boards</strong> you\'re a member of <strong>and</strong> have access to:',
    description: 'Header describing boards and workspaces',
  },
});

const BoardsAndWorkspaces: FunctionComponent = () => {
  const { clientName, resources } = useToken();
  const hasRestrictedWorkspace = resources?.length === 1;
  return (
    <Stack space="space.400">
      <Stack space="space.200">
        <Box>
          <FormattedMessage
            {...(hasRestrictedWorkspace
              ? messages.headerRestrictedWorkspace
              : messages.headerUnrestrictedWorkspace)}
            values={{
              appName: <strong>{clientName}</strong>,
              strong: (chunk) => <strong>{chunk}</strong>,
            }}
          />
        </Box>
        <GraphQLNotConnectedFallback errorText="Failed to retrieve workspace information">
          {hasRestrictedWorkspace ? (
            <RestrictedWorkspace />
          ) : (
            <WorkspacePanel />
          )}
        </GraphQLNotConnectedFallback>
      </Stack>
      <Box>
        <WorkspaceFooter
          hasRestrictedWorkspace={hasRestrictedWorkspace}
          clientName={clientName ?? ''}
        />
      </Box>
    </Stack>
  );
};

export default BoardsAndWorkspaces;
